import React from "react";
import {observer} from "mobx-react";
import {FlightsDatesSelectorModel} from "../../../services/flight-search/dates-selection/flights-dates-selector.model";
import {
    FlightDatesSelectorSwiperComponent,
    FlightDatesSelectorSwiperComponentProps
} from "./swiper/flight-dates-selector-swiper.component";
import {FlightDatesSelectorListComponent} from "./list/flight-dates-selector-list.component";
import {useContainerMediaQueriesChecks} from "../../../hooks/use-container-media-queries-checks.hook";
import {
    FlightScheduleAvailabilityStatusEnum
} from "../../../services/flights-schedule/flights-schedule.service.interface";


interface FlightDatesSelectorComponentProps {
    captureSelectedDateElementRef?: (date: Date, element: HTMLElement | null) => void;
    onDateSelected?: (date: Date) => void;
    flightsDatesSelector: FlightsDatesSelectorModel;
    swiperOptions?: Pick<FlightDatesSelectorSwiperComponentProps, 'hideFooter' | 'hideHeader' | 'onDone'>
}

export const FlightDatesSelectorComponent: React.FC<FlightDatesSelectorComponentProps> = observer((props) => {
    const containerMediaQueries = useContainerMediaQueriesChecks();



    const onDateClick = (date: Date) => {
        if(props.flightsDatesSelector.getDateAvailability(date).status !== FlightScheduleAvailabilityStatusEnum.Available) {
            return;
        }

        props.flightsDatesSelector.selectDate(date);
        if(props.onDateSelected) {
            props.onDateSelected(date);
        }
    }

    if(containerMediaQueries.smallScreen) {
        return (
            <FlightDatesSelectorListComponent flightsDatesSelector={props.flightsDatesSelector}
                                              onDateSelected={onDateClick}
                                              captureSelectedDateElementRef={props.captureSelectedDateElementRef}/>
        );
    } else {
        return (
            <FlightDatesSelectorSwiperComponent flightsDatesSelector={props.flightsDatesSelector}
                                                onDateClick={onDateClick}
                                                captureSelectedDateElementRef={props.captureSelectedDateElementRef}
                                                onDone={props.swiperOptions?.onDone}
                                                {...props.swiperOptions}/>
        );
    }

});
